<div class="banner" [class.only-image]="!title || !date || !local">
    <div class="banner-image" (click)="open()">
        <img width="1186" alt="Banner do evento" height="350" [src]="image" *ngIf="!skeleton">
        <ngx-skeleton-loader [theme]="{ 'height': '100%' }"></ngx-skeleton-loader>
    </div>
    <div class="banner-content" *ngIf="title && date && local" >
        <div class="w-100" *ngIf="!skeleton">
            <h3 class="banner-title">{{ title }}</h3>
            <p class="banner-date text-grad">{{ date }}</p>
            <p class="banner-location text-muted d-flex align-items-center">
                <i class="las la-map-marker text-grad me-2"></i> {{ local }}
            </p>
            <button class="btn btn-grad btn-lg mt-3 text-uppercase">Eu quero</button>
        </div>
        <div class="w-100" *ngIf="skeleton">
            <ngx-skeleton-loader [theme]="{ 'width': '80%', 'height': '35px', 'margin-bottom': '25px' }"></ngx-skeleton-loader>
            <br>
            <ngx-skeleton-loader [theme]="{ 'width': '35%', 'height': '50px', 'margin-bottom': '25px' }"></ngx-skeleton-loader>
            <br>
            <ngx-skeleton-loader [theme]="{ 'width': '60%', 'margin-bottom': '25px' }"></ngx-skeleton-loader>
            <br>
            <ngx-skeleton-loader [theme]="{ 'width': '116px', 'height': '46px', 'border-radius': '25px' }"></ngx-skeleton-loader>
        </div>
    </div>
</div>